import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { IDeclarationsForUpdateData } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  batchId: string;
  declarationsForUpdate: IDeclarationsForUpdateData[];
}

export const useBulkUpdateBatch = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ batchId, declarationsForUpdate }: HookProps) => {
      const result = await apiClient.batchesWorkflow.bulkUpdate.mutation({ params: { id: batchId }, body: { declarationsForUpdate } });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['batches'] });
      toast.success(`The batch was updated, it's in the processing queue now!`);
    },
    onError: (error) => {
      showErrorToast(error, 'Error updating the batch!');
    },
  });
};
